// extracted by mini-css-extract-plugin
export default {"noteCard":"NoteItem_noteCard__1TBBa","title":"NoteItem_title__5zIp1","content":"NoteItem_content__YufOs"};